import React from 'react';
import { Introductory } from 'Templates';
import { useLocal } from 'Source/App/Storage/Local';
import { localkey } from 'Source/App/Main/local-config';

export const Introduction = () => {
	const { getLocal } = useLocal(localkey.general);
	const { lightSource } = getLocal();
	
	return (
		<Introductory
			title='My Javascript Libraries'
			descriptions={[
				'Pure vanilla javascript.',
				'Re-inventing the wheel makes you an inventor.',
				'No dependencies.',
			]}
			link='/javascript/poppingjs'
			brandImage={
				<div>
					<img className={`hero-icon ${lightSource}`} alt="react logo" src='/images/tools/js.png' />
					<img
						className="hero-icon-secondary"
						alt="beard-guy" 
						src='/images/icons/icon-192x192.png'
					/>
				</div>
			}
			columns={[ 
				{
					title: 'Pure vanilla javascript',
					description: `These libraries are pure javascript without frameworks
					that support the library in some extent.`,
				},
				{
					title: 'Re-inventing the wheel',
					description: `To reinvent the wheel is to duplicate a basic method that has
					already previously been created or optimized by others. which makes
					it new and light-weight with modern solution.`,
				},
				{
					title: 'No dependencies',
					description: `it can bootstrap on it's own without relying on some
					dependencies that can add weight to your precious software.`,
				},
			]}
		/>
	);
};
